function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var _require = require('../constants'),
  STATUS_LABELS = _require.STATUS_LABELS,
  SEVERITY_LABELS = _require.SEVERITY_LABELS,
  PRIORITY_LABELS = _require.PRIORITY_LABELS;
var escapeHtml = function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
};
var options = function options(labels, selected) {
  return Object.entries(labels).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[0],
      label = _ref2[1];
    return "<option value=\"".concat(value, "\"").concat(value === selected ? ' selected' : '', ">").concat(label, "</option>");
  }).join('');
};
module.exports = function (mode) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var contentAvailable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var create = mode === 'create';
  var capture = mode === 'capture';
  var heading = create ? 'Create Bug' : capture ? 'Capture as Bug' : 'Edit Bug';
  return "\n    <form class=\"saito-overlay-form bugs-editor bugs-editor-form\" role=\"dialog\" aria-labelledby=\"bugs-editor-title\">\n      <div class=\"saito-overlay-form-header\">\n        <h2 class=\"saito-overlay-form-header-title\" id=\"bugs-editor-title\">".concat(heading, "</h2>\n      </div>\n      ").concat(create && !contentAvailable ? '<div class="saito-message-warning" role="alert">RedSquare composition is unavailable because the installed RedSquare module does not expose its composer API.</div>' : '', "\n      <label>Bug title\n        <input class=\"saito-input\" name=\"title\" maxlength=\"180\" required value=\"").concat(escapeHtml(values.title), "\" />\n      </label>\n      <label>Status\n        <select class=\"saito-form-select\" name=\"status\">").concat(options(STATUS_LABELS, values.status || 'open'), "</select>\n      </label>\n      <label>Severity\n        <select class=\"saito-form-select\" name=\"severity\">").concat(options(SEVERITY_LABELS, values.severity || 'medium'), "</select>\n      </label>\n      <label>Priority\n        <select class=\"saito-form-select\" name=\"priority\">").concat(options(PRIORITY_LABELS, values.priority || 'normal'), "</select>\n      </label>\n      <label>Assignee public key <span class=\"saito-help\">(optional)</span>\n        <input class=\"saito-input\" name=\"assignee_publickey\" autocomplete=\"off\" value=\"").concat(escapeHtml(values.assignee_publickey), "\" />\n      </label>\n      ").concat(capture ? "<label>Explanatory note <span class=\"saito-help\">(optional RedSquare reply)</span>\n              <textarea class=\"saito-textarea\" name=\"note\" rows=\"4\"></textarea>\n            </label>" : '', "\n      <div class=\"saito-button-row bugs-editor-actions\">\n        <button type=\"button\" class=\"saito-button-secondary bugs-editor-cancel\">Cancel</button>\n        <button type=\"submit\" class=\"saito-button-primary\"").concat(create && !contentAvailable ? ' disabled' : '', ">").concat(create ? 'Continue in RedSquare' : 'Save Bug', "</button>\n      </div>\n    </form>");
};